import gql from "graphql-tag";

export default gql`
  mutation cancelRecurringJob($data: DeleteRecurringJobInput!) {
    cancelRecurringJob(data: $data)
  }
`;